import { action, observable } from "mobx";

class FullScreenLoadingStore {
  @observable
  private _loading: boolean = false;

  public get loading() {
    return this._loading;
  }

  @action
  public setLoading(loading: boolean) {
    this._loading = loading;
  }
}

const fullScreenLoadingStore = new FullScreenLoadingStore();
export default fullScreenLoadingStore;
